import { ExternalPanelSpec, externalPanelSpecSchema } from '@/core';
import { createVisualization } from '@/plugin-system';
import { ExternalPanel, ExternalProps } from './ExternalPanel';
import { ExternalPanelIcon } from './ExternalPanelIcon';
import { ExternalPanelOptionsEditor } from './ExternalPanelOptionsEditor';

export const External = createVisualization(ExternalPanel, {
  dashboardConfig: {
    kind: 'External',
    mapSpecToProps: (spec: ExternalPanelSpec): Omit<ExternalProps, 'width' | 'height'> => ({
      url: spec.url,
      contentWidth: spec.content_width,
      contentHeight: spec.content_height,
    }),
    mapPropsToSpec: (props): ExternalPanelSpec => ({
      url: props.url,
      content_width: props.contentWidth,
      content_height: props.contentHeight,
    }),
    panelOptionsEditorComponents: [
      {
        label: 'External',
        content: ExternalPanelOptionsEditor,
      },
    ],
    createInitialOptions: () => ({ url: '' }),
    hideQueryEditor: true,
    schema: externalPanelSpecSchema,
    icon: ExternalPanelIcon,
  },
});

export type ExternalVizProps = React.ComponentProps<typeof External.Viz>;
export type ExternalVizBaseProps = React.ComponentProps<typeof External.VizBase>;
